// Puro, sem DOM — mapeamento pagamento/nó → propriedades visuais do grafo.
// Separado de graph.js (que importa 'force-graph', dependente de `window`)
// pra dar pra testar de unidade em Node puro.

const NODE_BASE_RADIUS = 9;
const NODE_RADIUS_SCALE = 6;
const EDGE_BASE_WIDTH = 1.4;
const EDGE_WIDTH_SCALE = 2;
const PARTICLE_BASE_SIZE = 2.5;
const PARTICLE_MAX_SIZE = 6;

export function volumeToNumber(bigintValue) {
  // Pagamentos de teste são pequenos (frações de SIMC); dividir como Number
  // é seguro aqui e evita carregar uma lib de bignum só pra escala visual.
  return Number(bigintValue) / 1e18;
}

function agentVolume(node) {
  return volumeToNumber(node.totalSent + node.totalReceived);
}

/** val do force-graph: proporcional a log(volume total enviado+recebido). */
export function nodeVal(node) {
  return Math.max(0.4, Math.log1p(agentVolume(node)));
}

export function nodeRadius(node) {
  return NODE_BASE_RADIUS + nodeVal(node) * NODE_RADIUS_SCALE;
}

export function edgeWidth(edge) {
  const vol = volumeToNumber(edge.volume);
  return EDGE_BASE_WIDTH + Math.log1p(vol) * EDGE_WIDTH_SCALE;
}

/** Largura da partícula pro pagamento: maior valor → partícula maior, capado. */
export function particleWidthForPayment(value) {
  const vol = volumeToNumber(value);
  return Math.min(PARTICLE_MAX_SIZE, PARTICLE_BASE_SIZE + Math.log1p(vol) * 1.1);
}

export function hexToRgba(hex, alpha) {
  const clean = (hex || '#898781').replace('#', '');
  const bigint = parseInt(clean.length === 3 ? clean.replace(/./g, (c) => c + c) : clean, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** Chave estável from|to usada tanto pelo store quanto pelo grafo pra casar edge. */
export function edgeKey(from, to) {
  return `${from}|${to}`;
}

/**
 * Mapeamento pagamento → link do grafo: dado o payment normalizado (ledger.js)
 * e o Map de links vivos (key -> link), devolve o link correspondente (ou
 * undefined se o nó/edge ainda não existir no grafo).
 */
export function resolveLinkForPayment(linkByKey, payment) {
  return linkByKey.get(edgeKey(payment.from, payment.to));
}
